import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { AttachmentComponent } from './attachment/attachment.component';
import { TabAttachmentsComponent } from './tab-attachments.component';


@NgModule({
  entryComponents: [
    TabAttachmentsComponent
  ],
  declarations: [
    TabAttachmentsComponent,
    AttachmentComponent
  ],
  imports: [
    TranslateModule,

    MatIconModule,

    FuseSharedModule
  ],
  exports: [
    TabAttachmentsComponent
  ]
})
export class TabAttachmentsModule { }
